import React from 'react'
import { Dialog } from 'primereact/dialog'
import HeartIcon from './HeartIcon'
import { useTranslation } from 'react-i18next'

const ReusableModal = ({
  isVisible,
  onClose,
  title = '',
  HeaderIcon = null,
  children,
  footerButtons = null,
  className = 'w-full md:w-[600px] lg:w-[700px]',
  position = 'center',
  favIcon = null,
  headerClassName = '',
  messagePaid = false
}) => {
  const { t } = useTranslation()
  const renderHeader = () => (
    <div className="flex justify-between align-items-center">
      <div className="flex items-center">
        {HeaderIcon && (
          <div className="icon-bg-container me-2">
            <HeaderIcon size={20} className="text-iconC" />
          </div>
        )}
        <h5 className="text-darkBg  text-[16px] md:text-[18px] lg:text-[20px] font-[600] capitalize">
          {title}
        </h5>
      </div>
      {messagePaid ? <div className="mx-4 flex items-center ">
        <div class="ball"></div>
        <span class="text-darkBg  text-[16px] md:text-[18px] lg:text-[20px] font-[600] capitalize ms-1">{t('Paid Items')}</span>
      </div> : null}
      {favIcon && <div className="mx-4">{favIcon}</div>}
    </div>
  )

  return (
    <Dialog
      position={position}
      visible={isVisible}
      onHide={onClose}
      header={renderHeader()}
      footer={footerButtons}
      className={`${className}  mt-6 lg:mt-[50px]`}
      modal
      draggable={false}
      closable
      pt={{
        closeButton: { className: 'icon-bg-container' },
        closebuttonicon: { className: 'text-red-500' },
        header: { className: `transition-colors duration-300 ${headerClassName}` },
      }}
    >
      {children}
    </Dialog>
  )
}

export default ReusableModal
